import { useState } from "react";
import { KeyRound, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useAuth } from "@/lib/auth-context";
import { useProjeto } from "@/lib/projeto-context";
import { NovoSubprojeto } from "./novo-subprojeto";
import { DialogoMudarSenha } from "./dialogo-mudar-senha";

export function Topbar() {
  const { profile, signOut } = useAuth();
  const { projetoAtivo, projetos, trocarProjeto } = useProjeto();
  const [mudarSenhaAberto, setMudarSenhaAberto] = useState(false);

  const iniciais =
    profile?.full_name
      ?.split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .join("") ?? "?";

  return (
    <header className="bg-background sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b px-4">
      <SidebarTrigger />
      <Separator orientation="vertical" className="mr-1 h-5" />

      {projetos.length > 0 && (
        <Select
          value={projetoAtivo?.id ?? undefined}
          onValueChange={(id) => void trocarProjeto(id)}
        >
          <SelectTrigger className="w-56" aria-label="Projeto ativo">
            <SelectValue placeholder="Selecionar projeto" />
          </SelectTrigger>
          <SelectContent>
            {projetos.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {/* Um subprojeto marca-se pela seta: sem ela, TGT e TGT-01
                    leem-se como dois clientes diferentes. */}
                {p.projeto_pai_id ? "↳ " : ""}
                {p.codigo} · {p.nome}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      <NovoSubprojeto />

      <div className="flex-1" />

      {/* O botão de tema saiu a 14/09: o cliente não quer modo escuro, e o
          menu da marca foi desenhado para um fundo claro. */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Menu do utilizador">
            <Avatar className="size-7">
              <AvatarFallback className="text-xs">{iniciais}</AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel className="font-normal">
            <div className="grid text-sm">
              <span className="font-medium">{profile?.full_name ?? "Sem nome"}</span>
              <span className="text-muted-foreground text-xs">{profile?.email}</span>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* ⚠ `preventDefault`: sem ele o dropdown fecha e desmonta o diálogo
              antes de este montar, e o modal nunca aparece. */}
          <DropdownMenuItem
            onSelect={(e) => {
              e.preventDefault();
              setMudarSenhaAberto(true);
            }}
          >
            <KeyRound className="size-4" />
            Mudar senha
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={() => void signOut()}>
            <LogOut className="size-4" />
            Terminar sessão
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DialogoMudarSenha open={mudarSenhaAberto} onOpenChange={setMudarSenhaAberto} />
    </header>
  );
}
